import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { CalendarDays, Boxes, ClipboardList, LogOut, Menu } from "lucide-react";
import { useState } from "react";
import Logo from "@/components/Logo";
import { clearEmployeeToken, getEmployee } from "@/lib/api";

const navItems = [
  { to: "/employee", label: "Calendar", icon: CalendarDays, end: true, testid: "emp-nav-calendar" },
  { to: "/employee/inventory", label: "Inventory", icon: Boxes, testid: "emp-nav-inventory" },
  { to: "/employee/checkouts", label: "Check-out / In", icon: ClipboardList, testid: "emp-nav-checkouts" },
];

export default function EmployeeLayout() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const emp = getEmployee();

  const logout = () => {
    clearEmployeeToken();
    navigate("/employee/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white grain">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#050505]/80 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              className="md:hidden p-2 -ml-2 text-white/80 hover:text-[#C9963F]"
              onClick={() => setOpen(!open)}
              data-testid="emp-mobile-menu-toggle"
            ><Menu size={20} /></button>
            <Logo size="sm" />
            <span className="hidden sm:inline-block text-[10px] uppercase tracking-[0.3em] text-[#C9963F] ml-2 border-l border-white/15 pl-3">Staff</span>
          </div>
          <div className="flex items-center gap-3">
            {emp && <span className="hidden sm:inline text-xs text-white/60" data-testid="emp-name-display">Hi, {emp.name}</span>}
            <button
              onClick={logout}
              data-testid="emp-logout-btn"
              className="inline-flex items-center gap-2 border border-white/15 text-white/80 px-3 py-2 text-sm hover:border-[#C9963F] hover:text-[#C9963F]"
            ><LogOut size={16} /> <span className="hidden sm:inline">Logout</span></button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-10 flex gap-8">
        <aside className="hidden md:block w-56 shrink-0">
          <nav className="space-y-1 sticky top-24" data-testid="emp-sidebar-nav">
            {navItems.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors border-l-2 ${
                    isActive ? "border-[#C9963F] text-[#C9963F] bg-[#C9963F]/5" : "border-transparent text-white/70 hover:text-white hover:border-white/30"
                  }`
                }
              >
                <it.icon size={16} strokeWidth={1.5} /> {it.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        {open && (
          <div className="md:hidden fixed inset-0 z-40 bg-black/80 backdrop-blur" onClick={() => setOpen(false)}>
            <div className="absolute left-0 top-16 w-64 bg-[#0a0a0a] border-r border-white/10 h-full p-4" onClick={(e) => e.stopPropagation()}>
              <nav className="space-y-1">
                {navItems.map((it) => (
                  <NavLink key={it.to} to={it.to} end={it.end} onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-3 text-sm border-l-2 ${
                        isActive ? "border-[#C9963F] text-[#C9963F] bg-[#C9963F]/5" : "border-transparent text-white/80"
                      }`
                    }
                  >
                    <it.icon size={16} strokeWidth={1.5} /> {it.label}
                  </NavLink>
                ))}
              </nav>
            </div>
          </div>
        )}

        <main className="flex-1 min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
